/**
 * O cliente e o armazém, um por app, e a ligação que o núcleo compartilhado usa.
 *
 * Sem `baseUrl`: o padrão do cliente é `/api`, relativo, que é o que serve os
 * três lugares onde este bundle roda — o site (mesma origem que a API), o
 * `vite dev` (o proxy finge que é), e o Electron (o servidor local desvia).
 * Um endereço fixo aqui quebraria os dois últimos.
 */

import { Armazem, NossoSempreAPI, configurarJellyfin, expirar, ligar } from '@nosso-sempre/shared';

export const api = new NossoSempreAPI({ aoExpirar: expirar });

export const armazem = new Armazem(api);

ligar({
  api,
  armazem,
  // O `localStorage` guarda duas bobagens — quem entrou e se este aparelho foi
  // trancado. A sessão de verdade é o cookie `HttpOnly`, que não passa por aqui.
  guardado: {
    ler: (c) => localStorage.getItem(c),
    gravar: (c, v) => localStorage.setItem(c, v),
    apagar: (c) => localStorage.removeItem(c),
  },
  aoVivo: api.temFluxo(),
});

/*
 * O Jellyfin é o servidor de filmes da casa e mora numa rede que só existe lá
 * dentro, então o endereço e a chave são de quem monta o app — aqui, do
 * ambiente do Vite. Sem chave o módulo fica quieto e a tela diz por quê.
 */
configurarJellyfin({
  endereco: import.meta.env.VITE_JELLYFIN_URL as string | undefined,
  chave: import.meta.env.VITE_JELLYFIN_KEY as string | undefined,
});
